import React, { useState } from 'react';
import { FiMessageCircle, FiAlertCircle, FiSend } from 'react-icons/fi';
import { toast } from '../Toast';
import SettingsModal from './SettingsModal';

export type PlanRequest = 'up' | 'down' | 'cancel';

const OPTIONS: { value: PlanRequest; title: string; hint: string }[] = [
    { value: 'up', title: 'Move up to a bigger plan', hint: 'More investors, more widgets, priority support' },
    { value: 'down', title: 'Move down to Starter', hint: 'Registry and announcement emails only — A$4,900 a year' },
    { value: 'cancel', title: 'Cancel at the end of the year', hint: 'Runs to 1 Sep 2027, then stops. Your data stays for 12 months.' },
];

interface Props {
    initial: PlanRequest;
    onClose: () => void;
}

// UI only: nothing is sent to the account manager yet
const PlanChangeModal: React.FC<Props> = ({ initial, onClose }) => {
    const [choice, setChoice] = useState<PlanRequest>(initial);
    const [note, setNote] = useState('');

    const send = () => {
        toast.info('Preview only: this isn’t connected yet, so no request was sent');
        onClose();
    };

    return <SettingsModal icon={<FiMessageCircle />} title="Request a Plan Change" sub="Your Investi account manager replies the same business day" onClose={onClose}
        footerNote="Goes to your account manager and accounts@investi.com.au"
        footer={<button type="button" className="btn-primary" onClick={send}><FiSend /> Send Request</button>}>
        <div className="label">What would you like to do?</div>
        <div className="options" role="radiogroup" aria-label="Plan change">
            {OPTIONS.map(o => <button key={o.value} type="button" role="radio" aria-checked={choice === o.value}
                className={`option${choice === o.value ? ' selected' : ''}`} onClick={() => setChoice(o.value)}>
                <span className="radio" />
                <span className="text"><strong>{o.title}</strong><span>{o.hint}</span></span>
            </button>)}
        </div>
        <label className="field">
            <span className="label">Anything we should know? <em>(optional)</em></span>
            <textarea rows={3} value={note} onChange={e => setNote(e.target.value)} />
        </label>
        <div className="modal-note warn"><FiAlertCircle /> Nothing changes until you confirm by email. The current plan runs to 1 September 2027.</div>
    </SettingsModal>;
};

export default PlanChangeModal;
